/* eslint-disable react/no-array-index-key */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import BackToAdminCentre from 'components/BackToAdminCentre'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import PartnerPlanAdminOverviewForm from 'containers/PartnerPlanAdminOverviewForm'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { modalShow, modalHide } from 'actions/modals'
import { getPartnerPlanOverviewPages, setSelectedOverviewPage, setCurrentOverviewPageActive, getPartnerPlanUploadLogs } from 'actions/partnerPlanAdmin'
import { createPartnerplanForFY, bulkUpdatePartnerPlanStatus } from 'actions/partnerPlan'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { hasAccess } from 'utils/hasAccess'

class PartnerPlanAdmin extends Component {
  static propTypes = {
    createPartnerplanForFY: PropTypes.func.isRequired,
    currentUser: PropTypes.object,
    getPartnerPlanOverviewPages: PropTypes.func.isRequired,
    getPartnerPlanUploadLogs: PropTypes.func.isRequired,
    modalHide: PropTypes.func.isRequired,
    modalShow: PropTypes.func.isRequired,
    partnerPlanAdmin: PropTypes.object.isRequired,
    routes: PropTypes.instanceOf(Array),
    setCurrentOverviewPageActive: PropTypes.func.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    setSelectedOverviewPage: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    currentUser: null,
  }

  componentDidMount() {
    hasAccess(this.props.currentUser, 'Partner Plan', this.props.history, 'RW', true)
    this.props.getPartnerPlanOverviewPages(this.props.currentUser.EmployeeId)
    this.props.getPartnerPlanUploadLogs(this.props.currentUser.EmployeeId, '1')
  }

  handlePartnerPlanUploadLogs = (noOfDays) => {
    this.props.getPartnerPlanUploadLogs(this.props.currentUser.EmployeeId, noOfDays)
  }  

  handleOpenPartnerPlanOverviewForm = (item) => {
    this.props.setSelectedOverviewPage(item)
    this.timeout = setTimeout(() => {
      this.props.modalShow('partnerPlanOverviewForm')
    }, 500)
  }

  handleCreatePartnerPlanFy = (fy) => {
    this.props.createPartnerplanForFY(this.props.currentUser.EmployeeId, fy)
  }

  handleBulkUpdatePartnerPlanStatus = (fy, status, modifiedBy) => {
    this.props.bulkUpdatePartnerPlanStatus(this.props.currentUser.EmployeeId, fy, status, modifiedBy)
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: 'Admin centre',
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const {
      routes, partnerPlanAdmin, currentUser, partnerPlanOverviewForm,
    } = this.props

    return (
      <MainLayout bannerNavProps={{ ...this.bannerProps() }} showSidebar={false} sidebarType="partnerSideBar">
        <BackToAdminCentre displayText="Partner plan administration" isAdmin={this.props.currentUser.IsAdmin} />
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              bulkUpdatePartnerPlanStatus={this.handleBulkUpdatePartnerPlanStatus}
              createPartnerplanForFY={this.handleCreatePartnerPlanFy}
              currentUser={currentUser}
              getPartnerPlanUploadLogs={this.handlePartnerPlanUploadLogs}
              openPartnerPlanOverviewForm={this.handleOpenPartnerPlanOverviewForm}
              partnerPlanAdmin={partnerPlanAdmin}
              partnerPlanOverviewForm={partnerPlanOverviewForm}
              setCurrentOverviewPageActive={this.props.setCurrentOverviewPageActive}
              setErrorMessage={this.props.setErrorMessage}
              setSelectedOverviewPage={this.props.setSelectedOverviewPage}
            />
            ))}
          <PartnerPlanAdminOverviewForm
            currentUser={currentUser}
            hide={this.props.modalHide}
          />
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  partnerPlanAdmin: state.partnerPlanAdmin,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getPartnerPlanOverviewPages,
  getPartnerPlanUploadLogs,
  setSelectedOverviewPage,
  createPartnerplanForFY,
  bulkUpdatePartnerPlanStatus,
  setCurrentOverviewPageActive,
  modalShow,
  modalHide,
})(PartnerPlanAdmin))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlanAdmin.js